var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var UnitTestRowViewerResult_1;
import { JSON, JsonSchema } from '@symon-ai/wisepipe-serialize';
import '@symon-ai/wisepipe-common-data'; // force import for JsonSchema
import './unitTestResultColumn'; // force import for JsonSchema
import './unitTestResultRow'; // force import for JsonSchema
import { UnitTestStatus } from './unitTestRun';
const schema = {
    $id: 'urn:wisepipe-common-computation:UnitTestRowViewerResult',
    type: 'object',
    properties: {
        unitTestID: { type: 'string', uid: 9 },
        status: { type: 'string', enum: Object.values(UnitTestStatus) }
    },
    required: ['unitTestID', 'status'],
    allOf: [
        {
            if: { properties: { status: { const: UnitTestStatus.NoSnapshotFound } } },
            then: {
                properties: {
                    // if no snapshot then return regular row viewer results
                    columns: { type: 'array', items: { $ref: 'urn:wisepipe-common-data:Column' } },
                    rows: {
                        type: 'array',
                        items: {
                            type: 'array',
                            items: {
                                type: ['boolean', 'string', 'number', 'null']
                            }
                        }
                    }
                },
                required: ['columns', 'rows']
            }
        },
        {
            if: {
                properties: {
                    status: { oneOf: [{ const: UnitTestStatus.Passed }, { const: UnitTestStatus.Failed }] }
                }
            },
            then: {
                properties: {
                    columns: { type: 'array', items: { $ref: 'urn:wisepipe-common-computation:UnitTestResultColumn' } },
                    rows: { type: 'array', items: { $ref: 'urn:wisepipe-common-computation:UnitTestResultRow' } }
                },
                required: ['columns', 'rows']
            }
        },
        {
            if: {
                properties: {
                    status: { const: UnitTestStatus.Running }
                }
            },
            then: {
                properties: {
                    progress: { type: 'number', minimum: 0, maximum: 1 },
                    continuationToken: { type: 'string', uid: 9 }
                },
                required: ['progress', 'continuationToken']
            }
        }
    ]
};
let UnitTestRowViewerResult = UnitTestRowViewerResult_1 = class UnitTestRowViewerResult {
    constructor(unitTestID, status, columns, rows, progress, continuationToken) {
        this.unitTestID = unitTestID;
        this.status = status;
        if (columns !== undefined)
            this.columns = columns;
        if (rows !== undefined)
            this.rows = rows;
        if (progress !== undefined)
            this.progress = progress;
        if (continuationToken !== undefined)
            this.continuationToken = continuationToken;
        JSON.validate(this, UnitTestRowViewerResult_1);
    }
};
UnitTestRowViewerResult = UnitTestRowViewerResult_1 = __decorate([
    JsonSchema(schema)
], UnitTestRowViewerResult);
export { UnitTestRowViewerResult };
//# sourceMappingURL=unitTestRowViewerResult.js.map